import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { faTurnDownRight } from '@fortawesome/pro-solid-svg-icons'

import type { OrderConfirmationDeviceRendererProps } from 'Modules/order/types/OrderConfirmation.types'

import { Badge } from 'Components/_theme'
import { FormattedCurrency } from 'Components/FormattedCurrency/FormattedCurrency'
import { Icon } from 'Components/Icon/Icon'
import { ImageWithFallback } from 'Components/ImageWithFallback/ImageWithFallback'

import { ImagePlaceholderTypesEnum } from 'Types/imagePlaceholders.type'

import { ORDER_CONFIRMATION_ROW } from '../OrderConfirmation.constants'

export const OrderConfirmationDeviceRow = (
  props: OrderConfirmationDeviceRendererProps & {
    isOrganisation: boolean
    shouldShowRequestIdColumn: boolean
  },
) => {
  const {
    deviceName,
    deviceRentalDuration,
    deviceImage,
    devicePrice,
    deviceQuantity,
    deviceId,
    deviceCustomerLabel,
    deviceColor,
    isBundleRow,
    isBundleItemRow,
    hideRentalPeriod,
    isPurchase,
    isOrganisation,
    shouldShowRequestIdColumn,
  } = props

  const orderId = isBundleRow ? null : deviceId

  return (
    <Row
      key={orderId}
      className="device-overview justify-content-right justify-content-md-between align-items-center"
      data-chosendevice={deviceName}
      data-copayment={devicePrice}
      data-orderid={orderId}
      data-testid={ORDER_CONFIRMATION_ROW}
    >
      <Col className="d-flex" md={6} xs={12}>
        {isBundleItemRow && (
          <Icon className="me-2" icon={faTurnDownRight} size={20} />
        )}

        <div className="pe-4">
          <ImageWithFallback
            alt={deviceName}
            placeholderType={ImagePlaceholderTypesEnum.newOrderFlow}
            src={deviceImage}
          />
        </div>

        <div className="d-flex flex-column justify-content-center">
          <strong>{deviceName}</strong>

          {!isBundleRow && (
            <>
              <span>
                <FormattedMessage
                  id="NewOrderConfirmation_quantity"
                  values={{
                    count: deviceQuantity,
                  }}
                />
              </span>
              <span>
                <FormattedMessage
                  id="NewOrderConfirmation_color"
                  values={{
                    color: deviceColor,
                  }}
                />
              </span>

              {isPurchase && (
                <span>
                  <Badge
                    className="mt-4"
                    color="yellow"
                    rounded
                    variant="secondary"
                  >
                    <FormattedMessage id="NewOrder_purchase" />
                  </Badge>
                </span>
              )}
            </>
          )}

          {deviceCustomerLabel && !isBundleRow && (
            <span>
              <FormattedMessage id="NewOrderConfirmation_label" />
              &nbsp;
              {deviceCustomerLabel}
            </span>
          )}
        </div>
      </Col>

      {shouldShowRequestIdColumn && (
        <Col
          className="d-none d-md-flex justify-content-end align-items-center"
          xs={2}
        >
          {!isBundleRow && deviceId}
        </Col>
      )}

      <Col
        className="d-none d-md-flex justify-content-end align-items-center"
        xs={2}
      >
        {isPurchase && !isBundleRow
          ? '-'
          : !isBundleRow &&
            !hideRentalPeriod && (
              <FormattedMessage
                id="NewOrderConfirmation_months"
                values={{
                  total: deviceRentalDuration,
                }}
              />
            )}
      </Col>

      <Col
        className="d-none d-md-flex justify-content-end align-items-center"
        xs={2}
      >
        {(isPurchase ? isOrganisation && !isBundleRow : !isBundleRow) && (
          <FormattedCurrency value={devicePrice} />
        )}
      </Col>
    </Row>
  )
}
